import React, { memo } from "react";
import PropTypes from "prop-types";
import { Box } from "@chakra-ui/react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

const TimePicker = ({ date, onChange, ...props }) => {
  return (
    <Box
      {...props}
      sx={{
        ".react-datepicker-wrapper input": {
          transitionProperty: "common",
          transitionDuration: "normal",
          fontSize: "sm",
          borderRadius: "sm",
          border: "2px solid",
          borderColor: "transparent",
          background: "gray.900",
          color: "gray.100",
          height: "auto",
          minHeight: "8",
          textAlign: "center",
          width: "6rem",
          _focus: {
            // borderColor: "brand.primary",
            borderColor: "transparent",
            background: "whiteAlpha.300",
          },
          _hover: {
            background: "whiteAlpha.200",
          },
        },
        ".react-datepicker": {
          border: "none",
        },
        ".react-datepicker .react-datepicker__header": {
          display: "none",
        },
        ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before":
          {
            borderBottomColor: "gray.600",
          },
        ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after":
          {
            borderBottomColor: "gray.500",
          },
        ".react-datepicker.react-datepicker--time-only": {
          boxShadow: "dark-lg",
        },
        ".react-datepicker__time-container .react-datepicker__time": {
          background: "gray.500",
          borderRadius: "none",
          color: "white",
        },
        ".react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box, .react-datepicker .react-datepicker__header":
          {
            borderRadius: "none",
          },
        ".react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover, .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected":
          {
            color: "white",
            background: "whiteAlpha.200",
          },
      }}
    >
      <DatePicker
        selected={date}
        onChange={onChange}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={1}
        timeCaption="Time"
        dateFormat="h:mm aa"
      />
    </Box>
  );
};

TimePicker.propTypes = {
  date: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
};

TimePicker.defaultProps = {
  date: undefined,
  onChange: undefined,
};

export default memo(TimePicker);
